import { SingleInputDateRangeField as BaseSingleInputDataRangeField } from "@mui/x-date-pickers-pro";
import { PickerTextField } from "./PickerTextField.tsx";
import type { SingleInputDateRangeFieldProps } from "@mui/x-date-pickers-pro";
import type { Dayjs } from "dayjs";
import { BaseInputV2Adornment } from "src/components/BaseInputV2/BaseInputV2Adornment.tsx";
import React, { forwardRef } from "react";
const ClearIcon = forwardRef(({ ownerState, ...restProps }: any, ref: any) => {
  return <i ref={ref} {...restProps} className="icon-15-clear_x" />;
});
const ClearButton = forwardRef(({ ownerState, ...restProps }: any, ref) => {
  return <BaseInputV2Adornment ref={ref} isAction={true} {...restProps} />;
});

export const SingleInputDateRangeField = forwardRef(
  (props: SingleInputDateRangeFieldProps<Dayjs>, ref: any) => {
    return (
      <BaseSingleInputDataRangeField
        ref={ref}
        {...props}
        slots={{
          ...props.slots,
          textField: PickerTextField,
          clearIcon: ClearIcon,
          clearButton: ClearButton,
        }}
        slotProps={{
          ...props.slotProps,
          textField: {
            ...props.slotProps?.textField,
            disabled: props.disabled, // otherwise input won't be disabled
          },
        }}
      />
    );
  },
);

Object.assign(SingleInputDateRangeField, {
  fieldType: "single-input",
});
